import api from '../utils/api';

/**
 * Service to handle all Single Business Permit (SBP) related API calls
 */
export const sbpService = {
    /**
     * Fetches formatted dashboard metrics from the SPBDashboardDisplayData procedure
     * @param {string|number} fy - Financial Year (e.g., 2025)
     * @param {string|number} subCountyId - Sub County ID (Optional)
     * @returns {Promise<Object>} The procedure output variables
     */
    getDashboardStats: async (fy, subCountyId) => {
        //console.log(`Frontend API Call: Fetching SBP Dashboard stats for FY: ${fy}, SubCounty ID: ${subCountyId}`);
        try {
            // We use params to ensure the URL is properly encoded
            const response = await api.get('/sbp/dashboard', {
                params: { 
                    fy, 
                    subCountyId
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching SBP Dashboard stats:", error);
            throw error; // Let the component handle the error UI
        }
    },

    /**
     * Export SBP dashboard data to Excel
     * This is a placeholder for future export logic
     */
    exportStats: async (fy, subCountyId) => {
        // Logic for triggering download would go here
    }
};
export const fetchSBPItemReport = async (financialYear, subCountyId) => {
    const response = await api.get(`/sbp/item-report`, { params: 
        { 
            financial_year: financialYear, 
            sub_county_id: subCountyId 
        }
    });
    return response.data;
};
export default sbpService;